export class ProductLabels extends window.BAO.CustomElement({
  SuperClass: HTMLFieldSetElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.item.elements.forEach((item) => {
      this.listeners.add(item, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(item, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    this.els.name.element.textContent = e.currentTarget.dataset.name
  }

  handleMouseLeave () {
    this.els.name.element.textContent = this.els.name.element.dataset.default
  }
}

if (!customElements.get('product-labels')) {
  customElements.define('product-labels', ProductLabels, {
    extends: 'fieldset',
  })
}
